import { useI18n } from "../i18n";
import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";

export const useStations = () => {
  const { t } = useI18n();
  const [stations, setStations] = useState([]);
  useEffect(() => {
    api.get("/stations").then((r) => setStations(r.data)).catch(() => toast.error(t("noStations")));
  }, [t]);
  return stations;
};

export const useTimer = (active, maxSeconds, onTimeout) => {
  const [elapsed, setElapsed] = useState(0);
  const timeoutRef = useRef(onTimeout);
  timeoutRef.current = onTimeout;
  useEffect(() => {
    if (!active) return undefined;
    const id = setInterval(() => setElapsed((e) => e + 1), 1000);
    return () => clearInterval(id);
  }, [active]);
  useEffect(() => {
    if (active && elapsed >= maxSeconds) timeoutRef.current();
  }, [active, elapsed, maxSeconds]);
  return [elapsed, setElapsed];
};
